import React from 'react';
import { Button, Card, Table } from 'react-bootstrap';

import { ProjectCostCollaboratorRate } from '../../../../types';
import { useTypedProjectCostContext } from '../../useTypedProjectCostContext';
import TableControls from '../TableControls';
import { formatCurrencyFromCents } from '../../utils';

type CollaboratorRatesTableProps = {
  companyId?: number;
  hideCompanyColumn?: boolean;
};

const CollaboratorRatesTable: React.FC<CollaboratorRatesTableProps> = ({ companyId, hideCompanyColumn = false }) => {
  const {
    getPagedCollaboratorRates,
    handleEditCollaboratorRate,
    handleDelete,
    saving,
  } = useTypedProjectCostContext<{
    getPagedCollaboratorRates: (companyId?: number | null) => {
      pageItems: ProjectCostCollaboratorRate[];
      totalItems: number;
      totalPages: number;
      currentPage: number;
    };
    handleEditCollaboratorRate: (item: ProjectCostCollaboratorRate) => void;
    handleDelete: (path: string, message: string) => Promise<void>;
    saving: boolean;
  }>();

  const paged = getPagedCollaboratorRates(companyId ?? null);
  const colSpan = hideCompanyColumn ? 6 : 7;

  return (
    <Card>
      <Card.Header>Taxas temporais por colaborador</Card.Header>
      <Card.Body className="table-responsive">
        <TableControls
          tableKey="collaboratorRates"
          placeholder="Buscar por colaborador, empresa, função, período, observações..."
          totalItems={paged.totalItems}
          totalPages={paged.totalPages}
          currentPage={paged.currentPage}
        />
        <Table size="sm" hover>
          <thead>
            <tr>
              <th>Colaborador</th>
              {!hideCompanyColumn && <th>Empresa</th>}
              <th>Função</th>
              <th>Taxa/h</th>
              <th>Início</th>
              <th>Fim</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {paged.pageItems.length === 0 ? (
              <tr>
                <td colSpan={colSpan} className="text-center text-muted py-3">
                  Nenhum registro encontrado.
                </td>
              </tr>
            ) : (
              paged.pageItems.map((item) => (
                <tr key={item.id}>
                  <td>{item.collaborator?.name || item.collaborator_id}</td>
                  {!hideCompanyColumn && <td>{item.collaborator?.company?.name || '—'}</td>}
                  <td>{item.collaborator?.role?.name || '—'}</td>
                  <td>{formatCurrencyFromCents(item.hourly_rate)}</td>
                  <td>{item.effective_start || '—'}</td>
                  <td>{item.effective_end || '—'}</td>
                  <td>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      className="me-2"
                      onClick={() => handleEditCollaboratorRate(item)}
                      disabled={saving}
                    >
                      Editar
                    </Button>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => void handleDelete(
                        `/api/projects/costs/collaborator-rates/${item.id}`,
                        'Excluir taxa temporal do colaborador?',
                      )}
                      disabled={saving}
                    >
                      Excluir
                    </Button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default CollaboratorRatesTable;
